export const TABS = ['schedules', 'configs', 'connections'] as const;

export type Tab = (typeof TABS)[number];
